<script>
import { http } from "../axios";
import { baseUrl, mySelfUrl } from "../server";
import { db } from "../plugins/firebase";
export default {
  data() {
    return {
      productsByDepartment: [],
      quantityProds: 0,
      shopCode: null,
      table: null,
      origin: null,
      currentProduct: {},
      additionalDialog: false,
      quantityProds: 0,
      selectedOptions: [],
      idList: -1
    };
  },
  watch: {
    hasItemsInCart() {
      if (
        this.$store.getters.getSelectedProducts.length > 0 &&
        this.$store.getters.getCartTimestamp === null
      ) {
        this.$store.commit("SET_CART_TIMESTAMP", new Date());
        console.log(`Creating timestamp at ${new Date()}`);
      } else if (
        this.$store.getters.getSelectedProducts.length === 0 &&
        this.$store.getters.getCartTimestamp !== null
      ) {
        this.$store.commit("SET_CART_TIMESTAMP", null);
        console.log(`Resetting timestamp!`);
      }
    }
  },
  computed: {
    hasItemsInCart() {
      return this.$store.getters.getSelectedProducts.length > 0;
    },
    getCartItems() {
      return this.$store.getters.getSelectedProducts;
    },
    getShopCode() {
      return this.shopCode;
    },
    getProducts() {
      let array = [];

      this.productsByDepartment.forEach(element => {
        let arrayTemp = [];

        element.products.sort(function(a, b) {
          return a.name
            .toLowerCase()
            .localeCompare(b.name.toLowerCase(), "es", { sensitivity: "base" });
        });

        element.products.forEach(p => {
          if (p.iva !== "") {
            arrayTemp.push(p);
          }
        });
        if (arrayTemp.length > 0) {
          array.push({ name: element.name, products: arrayTemp });
        }
      });

      array.sort(function(a, b) {
        return a.name
          .toLowerCase()
          .localeCompare(b.name.toLowerCase(), "es", { sensitivity: "base" });
      });

      return array;
    },
    hasToShowAdditionalDialog() {
      return this.additionalDialog;
    },
    getAdditionals() {
      return this.currentProduct.optionGroups;
    }
  },
  methods: {
    validateCartExpiration() {
      if (this.$store.getters.getCartTimestamp !== null) {
        const diffTime = Math.abs(
          new Date() - new Date(this.$store.getters.getCartTimestamp)
        );
        const diffMinutes = Math.ceil(diffTime / (1000 * 60));
        console.log(`Cart uptime is ${diffMinutes} min`);
        if (diffMinutes > 120) {
          console.log(
            `Resetting cart due to cart expiration ${diffMinutes} min`
          );
          this.$store.commit("SET_SELECTED_PRODUCTS", []);
        }
      }
    },
    addProductAdditionalDialog() {
      let selectedProds = this.getSelectedProducts;
      let prod = this.currentProduct;

      let totalAmount = parseFloat(prod.price);

      this.selectedOptions.forEach(element => {
        totalAmount += element.quantity * parseFloat(element.price);
      });

      let p = {
        department: prod.department,
        description: prod.description,
        image: prod.image,
        name: prod.name,
        sku: prod.sku,
        price: prod.price,
        quantity: 1,
        options: this.selectedOptions,
        totalAmount: totalAmount
      };

      selectedProds.push(p);
      this.$store.commit("SET_SELECTED_PRODUCTS", selectedProds);

      // console.log(selectedProds);
      this.dismissAdditionalDialog();
    },
    showAdditionalsModal(prod) {
      this.currentProduct = prod;
      this.additionalDialog = true;
      this.selectedOptions = [];
    },
    dismissAdditionalDialog() {
      this.additionalDialog = false;
      this.selectedOptions = [];
      this.currentProduct = {};
    },
    plusQuantity(prod) {
      let selectedProds = this.getSelectedProducts;
      let resp = selectedProds.filter(t => t.sku == prod.sku);

      let p = {};
      if (resp === null || resp.length === 0) {
        p = {
          department: prod.department,
          description: prod.description,
          image: prod.image,
          name: prod.name,
          sku: prod.sku,
          price: prod.price,
          quantity: 1,
          totalAmount: parseFloat(prod.price)
        };
      } else {
        p = resp[0];
        let index = selectedProds.indexOf(p);
        selectedProds.splice(index, 1);

        p.quantity++;
        p.totalAmount = parseFloat(p.price) * p.quantity;
      }

      selectedProds.push(p);
      this.$store.commit("SET_SELECTED_PRODUCTS", selectedProds);
    },
    lessQuantity(sku) {
      let selectedProds = this.getSelectedProducts;

      let resp = selectedProds.filter(t => t.sku == sku);

      let p = {};
      p = resp[0];

      let index = selectedProds.indexOf(p);
      selectedProds.splice(index, 1);

      p.quantity--;

      if (p.quantity > 0) {
        p.totalAmount = p.quantity * parseFloat(p.price);
        selectedProds.push(p);
      }
      this.$store.commit("SET_SELECTED_PRODUCTS", selectedProds);
    },
    getQuantity(sku) {
      let resp = this.getSelectedProducts.filter(t => t.sku == sku);
      if (resp === null || resp.length === 0) {
        return 0;
      } else {
        return resp[0].quantity;
      }
    },
    hasAdditionals(product) {
      return (
        product.optionGroups !== undefined && product.optionGroups.length > 0
      );
    },
    processCart() {
      const orderCodeStarts =
        window.location.href.indexOf("/Cart/") + "/Cart/".length;
      const orderCodeEnds = window.location.href.indexOf("#/");
      const orderCode = window.location.href.substring(
        orderCodeStarts,
        orderCodeEnds
      );

      let lastOrderCode = this.$store.getters.getOrderCode;
      if (lastOrderCode !== null && lastOrderCode !== orderCode) {
        console.log("Resetting state!");
        this.$store.commit("RESET_STATE");
      }

      this.$store.commit("SET_ORDER_CODE", orderCode);
      this.$store.commit("SET_WAITING_FOR_PAYMENT_COUNTER", 0);
      this.$store.commit("SET_CURRENT_ERROR_MESSAGE", null);
      this.$store.commit("SET_CURRENT_ERROR_LEVEL", "success");
      this.$store.commit("SET_ORDER_ERROR_BUTTON_CAPTION", null);
      this.$store.commit("SET_CURRENT_ERROR_DESCR", null);
      this.$store.commit("SET_IS_LOADING", true);

      http
        .get(`${baseUrl}/api/Order?OrderCode=${orderCode}`)
        .then(response => {
          this.$store.commit("SET_IS_LOADING", false);
          if (response.data.responseCode === 0) {
            this.processOrderStatus(response);
          } else {
            this.$store.commit("SET_CURRENT_ERROR_LEVEL", "error");
            this.$store.commit("SET_ORDER_ERROR_BUTTON_CAPTION", null);
            this.$store.commit(
              "SET_CURRENT_ERROR_MESSAGE",
              "Oops, tuvimos un problema procesando el pedido"
            );
            this.$store.commit(
              "SET_CURRENT_ERROR_DESCR",
              response.data.responseMessage
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.$store.commit("SET_IS_LOADING", false);
          this.$store.commit("RESET_STATE");
          this.$store.commit("SET_CURRENT_ERROR_LEVEL", "error");
          this.$store.commit(
            "SET_CURRENT_ERROR_MESSAGE",
            "Oops, tuvimos un problema y no encontramos tu pedido. Revisa la URL por favor y que contenga el código que te dimos a tu WhatsApp"
          );
        });
    },
    loadProductList(shopCode, origin) {
      const t = this;
      db.ref(`products/${shopCode}`)
        .once("value")
        .then(function(snapshot) {
          var list = snapshot.val();
          if (list && list.idList != null) {
            t.refreshProductList(list.idList, t, origin);
          } else {
            t.$store.commit("SET_IS_LOADING", false);
            t.$store.commit("RESET_STATE");
            t.$store.commit("SET_CURRENT_ERROR_LEVEL", "error");
            t.$store.commit(
              "SET_CURRENT_ERROR_MESSAGE",
              `Oops, tuvimos un problema y no podemos mostrarte el menú. Aún no está cargado el menú para el comercio #${shopCode}.`
            );
          }
        });
    },
    toCountdown(totalSecondsToDump) {
      let counter = this.$store.getters.getWaitingForPaymentCounter;
      const secs = totalSecondsToDump - counter;
      if (secs <= 0) {
        clearInterval(this.$store.getters.getWaitingForPaymentInterval);
        return "00:00";
      }

      const minutes = Math.floor(secs / 60);
      let seconds = Math.floor(secs % 60).toFixed(0);

      if (seconds < 10) {
        seconds = `0${seconds}`;
      }
      this.$store.commit("SET_WAITING_FOR_PAYMENT_COUNTER", ++counter);
      return `${minutes}:${seconds}`;
    },
    refreshProductList(idList, t, selectedOriginParam) {
      t.productsByDepartment = [];
      t.quantityProds = 0;

      let selectedOrigin = "weborders";
      if (selectedOriginParam !== null && selectedOriginParam !== undefined) {
        selectedOrigin = selectedOriginParam;
      }

      db.ref(`listProducts/${idList}/products`).once("value", snapshot => {
        const resp = snapshot.val();
        if (resp != null) {
          var list = Object.entries(resp);
          t.loaded = true;

          list.forEach(element => {
            var prod = element[1];
            if (prod.origins === undefined) {
              return;
            }

            var o = prod.origins.find(
              o => o.name.toLowerCase() === selectedOrigin.toLowerCase()
            );

            if (o !== undefined) {
              var d = t.productsByDepartment.findIndex(
                d => d.name === prod.department
              );
              if (d !== -1) {
                // Categoria existente
                t.productsByDepartment[d].products.push({
                  name: prod.name,
                  description: prod.description,
                  image: prod.image,
                  price: o.price,
                  sku: prod.sku,
                  orderInMenu: prod.orderInMenu,
                  optionGroups: prod.optionGroups,
                  stock: prod.stock
                });
              } else {
                // Primero de cada categoria
                var array = [];
                array.push({
                  name: prod.name,
                  description: prod.description,
                  image: prod.image,
                  price: o.price,
                  sku: prod.sku,
                  orderInMenu: prod.orderInMenu,
                  optionGroups: prod.optionGroups,
                  stock: prod.stock
                });
                t.productsByDepartment.push({
                  name: prod.department,
                  products: array
                });
              }
              t.quantityProds += 1;
            }
          });

          // console.log('Product list is:');
          // console.log(t.productsByDepartment);
        }
      });
    },
    createNewOrder() {
      this.$store.commit("SET_IS_LOADING", true);

      http
        .post(`${baseUrl}/api/Order`, {
          previousOrderCode: this.$store.getters.getOrderCode
        })
        .then(response => {
          this.$store.commit("SET_IS_LOADING", false);
          if (response.data.responseCode === 0) {
            window.location.href = `${mySelfUrl}/Cart/${response.data.orderCode}#`;
          } else {
            this.$store.commit("SET_CURRENT_ERROR_LEVEL", "error");
            this.$store.commit("SET_ORDER_ERROR_BUTTON_CAPTION", null);
            this.$store.commit(
              "SET_CURRENT_ERROR_MESSAGE",
              "Oops, tuvimos un problema procesando el pedido"
            );
            this.$store.commit(
              "SET_CURRENT_ERROR_DESCR",
              response.data.responseMessage
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.$store.commit("SET_IS_LOADING", false);
          this.$store.commit("RESET_STATE");
          this.$store.commit("SET_CURRENT_ERROR_LEVEL", "error");
          this.$store.commit(
            "SET_CURRENT_ERROR_MESSAGE",
            "Oops, tuvimos un problema y no encontramos tu pedido. Revisa la URL por favor y que contenga el código que te dimos a tu WhatsApp"
          );
        });
    },
    processOrderStatus(response) {
      this.shopCode = response.data.shopCode;
      if (response.data.status === "PresumedDelivered") {
        this.createNewOrder();
      } else if (response.data.status === "Delivered") {
        this.createNewOrder();
      } else if (response.data.status === "Created") {
        console.log("CREATED");
        this.loadProductList(response.data.shopCode);
      } else if (response.data.status === "WaitingForPayment") {
        if (this.$store.getters.getWaitingForPaymentInterval !== null) {
          clearInterval(this.$store.getters.getWaitingForPaymentInterval);
        }

        this.$store.commit("SET_WAITING_FOR_PAYMENT_INTERVAL", null);
        this.$store.commit("SET_CURRENT_ERROR_LEVEL", "success");
        this.$store.commit("SET_ORDER_ERROR_BUTTON_CAPTION", null);
        this.$store.commit(
          "SET_CURRENT_ERROR_MESSAGE",
          "Tu pedido anterior sigue vigente pero aun no ha sido pagado."
        );

        if (
          this.$store.getters.getWaitingForPaymentInterval === null &&
          response.data.secondsToDump
        ) {
          const interval = setInterval(() => {
            this.$store.commit(
              "SET_CURRENT_ERROR_DESCR",
              `Tiempo restante para hacer el pago: ${this.toCountdown(
                response.data.secondsToDump
              )}`
            );
          }, 1000);

          this.$store.commit("SET_WAITING_FOR_PAYMENT_INTERVAL", interval);
        }
      } else if (response.data.status === "PaymentConfirmed") {
        this.$store.commit("RESET_STATE");
        this.$store.commit("SET_CURRENT_ERROR_LEVEL", "success");
        this.$store.commit("SET_ORDER_ERROR_BUTTON_CAPTION", null);
        this.$store.commit(
          "SET_CURRENT_ERROR_MESSAGE",
          "Ya recibimos el pago de tu pedido y está siendo procesado"
        );
        this.$store.commit(
          "SET_CURRENT_ERROR_DESCR",
          "Estamos preparando tu pedido. Recibirás una notificación cuando lo despachemos"
        );
      } else if (response.data.status === "Dumped") {
        if (response.data.anyAvailableOrderCode !== null) {
          window.location.href = `${mySelfUrl}/Cart/${response.data.anyAvailableOrderCode}#`;
        } else {
          this.$store.commit("SET_CURRENT_ERROR_LEVEL", "error");
          this.$store.commit(
            "SET_ORDER_ERROR_BUTTON_CAPTION",
            "Hacer pedido aquí"
          );
          this.$store.commit(
            "SET_CURRENT_ERROR_MESSAGE",
            "Tu pedido anterior fue cancelado porque no recibimos tu pago, o no terminaste de confirmar el pedido"
          );
          this.$store.commit(
            "SET_CURRENT_ERROR_DESCR",
            "Por favor desestimá el link de pago que recibiste oportunamente y volvé a realizar tu pedido haciendo click aquí:"
          );
        }
      } else {
        this.$store.commit("SET_CURRENT_ERROR_LEVEL", "error");
        this.$store.commit("SET_ORDER_ERROR_BUTTON_CAPTION", null);
        this.$store.commit(
          "SET_CURRENT_ERROR_MESSAGE",
          "Tu pedido esta en un estado desconocido"
        );
        this.$store.commit("SET_CURRENT_ERROR_DESCR", response.data.status);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/mixins/Cart_Mixin.vue